import { LINE_SERIES_WIDTH_PX } from "../constants";

const SEGMENT_FLOATS = 4;

/**
 * Instances of the Line chart (Area with a gradient, D16): segments between
 * neighbouring closes for the band renderer and the same segments with
 * colour and width for the line renderer. Prices are relative to
 * `priceBase` (see mainSeries); there are bars.length - 1 segments.
 *
 * @param {object[]} bars - { close }
 * @param {number} priceBase
 * @param {object} params
 * @param {number} params.firstIndex - bar index of bars[0], when only the tail is rebuilt
 * @param {number[]} params.color - RGBA 0..1 of the line
 * @param {number} params.floatsPerLine - lineRenderer.floatsPerInstance
 * @returns {{ band: Float32Array, line: Float32Array }}
 */
export const buildLineAreaInstances = (bars, priceBase, { firstIndex, color, floatsPerLine }) => {
  const segmentCount = Math.max(0, bars.length - 1);
  const band = new Float32Array(segmentCount * SEGMENT_FLOATS);
  const line = new Float32Array(segmentCount * floatsPerLine);

  for (let position = 0; position < segmentCount; position += 1) {
    const index = firstIndex + position;
    const segment = [
      index,
      bars[position].close - priceBase,
      index + 1,
      bars[position + 1].close - priceBase,
    ];
    const lineOffset = position * floatsPerLine;

    band.set(segment, position * SEGMENT_FLOATS);
    line.set(segment, lineOffset);
    line.set(color, lineOffset + SEGMENT_FLOATS);
    line[lineOffset + floatsPerLine - 1] = LINE_SERIES_WIDTH_PX;
  }

  return { band, line };
};
